/**
 * Language tabs on /api-docs. Every endpoint renders its request sample once per language
 * (views/data/apiDocsSamples.ts); the tab strips are switched together, and the choice is
 * kept in localStorage so a PHP shop sees PHP on every visit.
 */
import { registerActions } from "../actionRegistry";
import { queryAll } from "../utils/dom";

const KEY = "PictufyApiDocsLang";

export function apiDocsLang(lang: string): void {
  if (!/^[a-z]+$/.test(lang)) return;
  if (!document.querySelector(`.api-sample[data-lang="${lang}"]`)) return;
  for (const el of queryAll<HTMLElement>(".api-tab")) {
    el.classList.toggle("api-tab-active", el.dataset.lang === lang);
  }
  for (const el of queryAll<HTMLElement>(".api-sample")) {
    el.classList.toggle("api-sample-active", el.dataset.lang === lang);
  }
  try {
    localStorage.setItem(KEY, lang);
  } catch {
    // Private mode / blocked storage: the tabs still work for this visit.
  }
}

/** Restore the remembered language on load. Cheap no-op on every other page. */
function restore(): void {
  if (!document.querySelector(".api-sample")) return;
  try {
    const lang = localStorage.getItem(KEY);
    if (lang) apiDocsLang(lang);
  } catch {
    // ignore
  }
}
if (typeof document !== "undefined") {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", restore);
  else restore();
}

registerActions({ apiDocsLang });
